import {Component, DestroyRef, DoCheck, OnInit} from '@angular/core';
import {MetaData, NgEventBus} from 'ng-event-bus';
import {ControlContainer, FormsModule, NgForm} from '@angular/forms';
import {NgSelectModule} from '@ng-select/ng-select';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {LookupService} from '../../common/service/lookup.service';
import {PlanModelService} from '../../common/service/plan-model.service';
import {NlrHasPermissionsPipe} from '../../common/pipe/nlr-has-permissions.pipe';
import {NlrPermissionsDisabledPipe} from '../../common/pipe/nlr-permissions-disabled-pipe';
import {ProjectedCoordSystemLookup} from '../../common/models/projected-coord-system.model';
import {SpatialUtilService} from '../../design/services/spatial-util.service';

@Component({
    selector: 'nlr-projected-coord-system',
    imports: [FormsModule, NlrHasPermissionsPipe, NlrPermissionsDisabledPipe, NgSelectModule],
    templateUrl: './projected-coord-system.component.html',
    styleUrl: './projected-coord-system.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class ProjectedCoordSystemComponent implements OnInit, DoCheck {
    get readonly() {
        return this.planModelService.readonly;
    }

    allProjectedCoordSystemLookups = [];
    projectedCoordSystems = [];

    constructor(
        private eventBus: NgEventBus,
        private lookupService: LookupService,
        private planModelService: PlanModelService,
        private spatialUtilService: SpatialUtilService,
        private destroyRef: DestroyRef
    ) {}

    ngOnInit() {
        this.allProjectedCoordSystemLookups = this.lookupService
            .getLookups('projectedCoordSystem')
            .sort((a: ProjectedCoordSystemLookup, b: ProjectedCoordSystemLookup) => a.uiOptionOrder - b.uiOptionOrder);

        this.eventBus
            .on('nlr:plan-model-updated:*')
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((meta: MetaData) => {
                if (meta.data === 'planPurpose') {
                    this.planModelService.getModel().spatialSettings.projectedCoordSystem = undefined;
                }
            });
    }

    ngDoCheck() {
        const filteredProjectedCoordSystemLookups = this.allProjectedCoordSystemLookups.filter(
            (l: ProjectedCoordSystemLookup) => l.validPdfCreationMethods && l.validPdfCreationMethods.includes(this.getModel().pdfCreationMethod)
        );

        if (
            this.projectedCoordSystems.length !== filteredProjectedCoordSystemLookups.length ||
            !this.projectedCoordSystems.every((v, i) => v === filteredProjectedCoordSystemLookups[i])
        ) {
            this.projectedCoordSystems = filteredProjectedCoordSystemLookups;
        }
    }

    getModel() {
        return this.planModelService.getModel();
    }

    disableProjectedCoordSystem() {
        return (
            this.planModelService.getGuid() &&
            this.planModelService.getModel().spatialSettings.projectedCoordSystem &&
            this.spatialUtilService.getGeometryFeatureCount()
        );
    }

    projectedCoordSystemChange(projectedCoordSystem) {
        this.planModelService.getModel().spatialSettings.projectedCoordSystem = projectedCoordSystem;
        // Only initiate the design content when a survey method has been selected. Statutory/digital plans do not display
        // the survey details, so the design framework cannot be initialised from here and the event would only raise an error.
        if (this.planModelService.getModel().surveyMethod) {
            this.eventBus.cast('initiateDesignContent', {
                reload: true,
                splitter: false,
                initProjection: true
            });
        }
    }
}
